export const IssuableType = {
  Issue: 'issue',
  Incident: 'incident',
  TestCase: 'test_case',
};
